import { Grid, styled } from "@mui/material";
import { IconBuildingPlus } from "@tabler/icons-react";
import MxTypography from "@rf-l1/MxTypography";
import MxButtonStartIcon from "@rf-l1/buttons/MxButtonStartIcon";
import { IMxCatchmentEmptyState } from "../model/catchment.interface";

/**
 * Estado vacío para cuando no hay etapas agregadas
 * Muestra un mensaje informativo y botón para agregar la primera etapa
 */
export const MxCatchmentEmptyState = ({
  onAdd,
  message = "No hay etapas agregadas aún en el proyecto",
  buttonLabel = "Agregar etapa"
}: IMxCatchmentEmptyState) => {
  return (
    <StyledEmptyStateContainer
      container
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <MxTypography variant="caption" color="grey.500" fontWeight={500}>
        {message}
      </MxTypography>

      <MxButtonStartIcon
        onClick={onAdd}
        label={buttonLabel}
        bgColorIcon="primary.main"
        colorText="grey.800"
        icon={<IconBuildingPlus size={19} color="white" />}
      />
    </StyledEmptyStateContainer>
  );
};

export default MxCatchmentEmptyState;

const StyledEmptyStateContainer = styled(Grid)(({ theme }) => ({
  height: 200,
  rowGap: theme.spacing(2)
}));
